import { PendingRespondentStatus, SearchParams, SortModelItem } from 'src/@types/pendingRespondentStatus';

const PAGE_SIZE = 100;
export type Action =
  | { type: 'SET_SORT_MODEL'; payload: SortModelItem[] }
  | { type: 'SET_SEARCH_TEXT'; payload: string }
  | { type: 'SET_DELETABLE'; payload: boolean }
  | { type: 'SET_STATUS'; payload: 'ALL' | PendingRespondentStatus }
  | { type: 'SET_CURRENT_PAGE'; payload: number }
  | { type: 'RESET' };

export const initialState: SearchParams = {
  sortModel: [],
  searchText: '',
  deletable: false,
  status: 'ALL',
  currentPage: 1,
  pageSize: PAGE_SIZE,
};

export const reducer = (state: SearchParams, action: Action): SearchParams => {
  switch (action.type) {
    case 'SET_SORT_MODEL':
      return { ...state, sortModel: action.payload };
    case 'SET_SEARCH_TEXT':
      return { ...state, searchText: action.payload };
    case 'SET_DELETABLE':
      return { ...state, deletable: action.payload };
    case 'SET_STATUS':
      return { ...state, status: action.payload };
    case 'SET_CURRENT_PAGE':
      return { ...state, currentPage: action.payload };
    case 'RESET':
      return initialState;
    default:
      return state;
  }
};

export const actions = {
  setSortModel: (sortModel: SortModelItem[]): Action => ({
    type: 'SET_SORT_MODEL',
    payload: sortModel,
  }),

  setSearchText: (searchText: string): Action => ({
    type: 'SET_SEARCH_TEXT',
    payload: searchText,
  }),

  setDeletable: (deletable: boolean): Action => ({
    type: 'SET_DELETABLE',
    payload: deletable,
  }),

  setStatus: (status: 'ALL' | PendingRespondentStatus): Action => ({
    type: 'SET_STATUS',
    payload: status,
  }),

  setCurrentPage: (page: number): Action => ({
    type: 'SET_CURRENT_PAGE',
    payload: page,
  }),

  reset: (): Action => ({
    type: 'RESET',
  }),
};
